import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi2";
import "./StartProject.scss";
import Button from "../../common/Button/Button";

const StartProject = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [isValid, setIsValid] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateEmail(email)) {
            setIsValid(false);
            return;
        }

        setIsSubmitting(true);

        setTimeout(() => {
            sessionStorage.setItem("projectEmail", email);
            window.scrollTo({ top: 0, behavior: "instant" });
            navigate("/project-flow");
            setIsSubmitting(false);
        }, 500);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        if (!isValid) setIsValid(true);
    };

    return (
        <section id="email-capture" className="start-project">
            <div className="start-project__container">
                <div className="start-project__content">
                    <h2 className="start-project__title">
                        Encuentra el partner perfecto para tu proyecto 3D
                    </h2>
                    <p className="start-project__subtitle">
                        Conectamos tu visión con los mejores profesionales de
                        captura y modelado 3D. Solo necesitas tu email para
                        comenzar.
                    </p>

                    <form
                        className="start-project__form"
                        onSubmit={handleSubmit}
                    >
                        <div
                            className={`form-input-wrapper ${
                                !isValid ? "form-input-wrapper--error" : ""
                            }`}
                        >
                            <input
                                type="email"
                                value={email}
                                onChange={handleEmailChange}
                                placeholder="tu@email.com"
                                required
                                disabled={isSubmitting}
                                className="form-input"
                            />
                            <Button
                                variant="filled"
                                icon={<HiArrowRight />}
                                className="form-submit"
                                animated={true}
                                animationType="pop"
                            >
                                {isSubmitting ? "Procesando..." : "Siguiente"}
                            </Button>
                        </div>
                        {!isValid && (
                            <span className="error-message">
                                Por favor, introduce un email válido
                            </span>
                        )}
                    </form>

                    <p className="start-project__note">
                        * Al continuar, aceptas nuestra Política de Privacidad y
                        nos das permiso para ponernos en contacto contigo y
                        ofrecerte la mejor ayuda posible para tu proyecto. Tu
                        información siempre estará protegida.
                    </p>
                </div>

                <div className="visual-card">
                    <div className="visual-card__content">
                        <div className="step-indicator">
                            <span className="step-number">1</span>
                            <span className="step-text">
                                Describe tu proyecto
                            </span>
                        </div>
                        <div className="step-indicator">
                            <span className="step-number">2</span>
                            <span className="step-text">Recibe propuestas</span>
                        </div>
                        <div className="step-indicator">
                            <span className="step-number">3</span>
                            <span className="step-text">Elige tu partner</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default StartProject;
